import { render, staticRenderFns } from "./InputRadioGroup.vue?vue&type=template&id=3244ba50&scoped=true&"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js&"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./InputRadioGroup.vue?vue&type=style&index=0&id=3244ba50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244ba50",
  null
  
)

export default component.exports